// modules
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// constants
import { Routes } from "constants/global";

// utils
import { invalidateCookie } from "utils/token";

// redux
import { useAppDispatch } from "app/hooks/hooks";
import { resetAppData } from "redux/userList/userSlice";
import { resetClaimState } from "redux/retroClaim/retroClaimSlice";
import { resetReimbState } from "redux/reimbursement/reimbursementSlice";
import { resetRoleManagementState } from "redux/roleManagement/roleManagementSlice";

// Auth provider
import { Auth } from "app/hooks/Auth";

function useLogOut() {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		const userPool = new Auth().getUserPool();

		const currentUser = userPool?.getCurrentUser();

		if (currentUser) {
			currentUser?.signOut();
		}
		dispatch(resetAppData());
		dispatch(resetClaimState());
		dispatch(resetReimbState());
		dispatch(resetRoleManagementState());
		invalidateCookie();
		localStorage.clear();
		navigate(Routes?.LOGIN);
	});
}

const Logout = () => {
	useLogOut();

	return null;
};

export default Logout;
